import React from 'react';
import { GlobalStyles } from '@mui/material';

/**
 * Provides global style overrides for MUI menus to fix mobile interaction issues.
 * This is especially important for context menus in mobile view.
 */
const MenuOverrides: React.FC = () => {
  return (
    <GlobalStyles
      styles={{
        // Ensure menus are always on top
        '.MuiMenu-root': {
          zIndex: 1400, // Higher than drawer/sidebar
        },

        // Ensure menu items work properly on mobile
        '.MuiMenuItem-root': {
          touchAction: 'none', // Prevent default touch behavior
        },

        // Prevent content from moving when dialog opens
        'body.mui-fixed': {
          paddingRight: '0 !important',
        },

        // Ensure dialogs are on top of everything
        '.MuiDialog-root': {
          zIndex: 1500,
        },
      }}
    />
  );
};

export default MenuOverrides;
